/**
 * Specialty-aware display helpers for subject/unit/topic codes.
 * PM&R shows field codes (e.g. "C Cardiovascular"), Pain & Sports show name only.
 */

/**
 * Whether field codes should be displayed for a given specialty.
 * @param {string} specialtyId — 'pmr', 'pain', or 'sports'
 * @returns {boolean}
 */
export const shouldShowCodes = (specialtyId) => {
  return specialtyId === 'pmr' || !specialtyId;
};

/**
 * Returns the display name for a subject/unit/topic item.
 * PM&R: "C Cardiovascular"   Pain/Sports: "Cardiovascular"
 * @param {object} item — must have .name, optionally .code
 * @param {string} specialtyId — active specialty id
 * @returns {string}
 */
export const getDisplayName = (item, specialtyId) => {
  if (!item) return 'Unknown';
  if (shouldShowCodes(specialtyId) && item.code) {
    return `${item.code} ${item.name}`;
  }
  return item.name || 'Unknown';
};
